/* @flow */
import * as React from 'react';

import Colors from '../../constants/Colors';
import { Text, CircleBadge } from '.';
import type { ResponsiveValue } from '../../constants/Responsive';
import type { SupportedFontSize } from '../../components/core/Text';

function NumberedCircleBadge({
  children,
  style,
  className,
  fontSize = '18',
}: {
  children?: any,
  style?: Object,
  className?: string,
  fontSize?: SupportedFontSize | ResponsiveValue<SupportedFontSize>,
}) {
  return (
    <CircleBadge className={className} style={style}>
      <Text size={fontSize} weight="medium" color={Colors.White}>
        {children}
      </Text>
    </CircleBadge>
  );
}

export default NumberedCircleBadge;



// WEBPACK FOOTER //
// ./src/ui/components/core/NumberedCircleBadge.js